module.exports = __webpack_public_path__ + "static/img/263_TO8_2345_og.dca25ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/263_TO8_2345_og.jpg
// module id = NVIY
// module chunks = 0